import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from '../../services/api'; // Adjust path if needed

// Async thunk to get dashboard count
export const fetchDashboardCount = createAsyncThunk(
  "dashboard/fetchCount",
  async (params={}, { rejectWithValue }) => {
    try {
      const response = await GET("/admin/dashboard/count", {...params});
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to fetch dashboard data");
    }
  }
);



export const fetchDashboardUsers = createAsyncThunk(
    "dashboard/fetchUsers",
    async (params={}, { rejectWithValue }) => {
      try {
        const response = await GET("/admin/dashboard/user", {...params});
        if (response?.status === 200) {
          return response.data.result;
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to fetch dashboard users");
      }
    }
  );

  export const fetchDashboardPodcastListener = createAsyncThunk(
    "dashboard/fetchPodcastListener",
    async (params={}, { rejectWithValue }) => {
      try {
        const response = await GET(`/admin/dashboard/date`, {...params});
        if (response?.status === 200) {
          return response.data.result;
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to fetch dashboard podcast data");
      }
    }
  );


  export const listTop100Listeners = createAsyncThunk(
    'topListeners/list',
    async (params = {}, { rejectWithValue }) => {
      try {
        const response = await GET('/admin/dashboard/top-most-listened', {...params});
  
        if (response?.status === 200) {
          return response.data;
        }
  
        return rejectWithValue(response?.data || 'Something went wrong');
      } catch (error) {
        return rejectWithValue(
          error?.response?.data?.message || error?.message || 'Failed to fetch top listeners'
        );
      }
    }
  );


  export const listTopLeastListeners = createAsyncThunk(
    'topLeastListeners/list',
    async (params = {}, { rejectWithValue }) => {
      try {
        const response = await GET('/admin/dashboard/top-least-listened', {...params});
  
        if (response?.status === 200) {
          return response.data;
        }
  
        return rejectWithValue(response?.data || 'Something went wrong');
      } catch (error) {
        return rejectWithValue(
          error?.response?.data?.message || error?.message || 'Failed to fetch top listeners'
        );
      }
    }
  );


  export const listTopTenListeners = createAsyncThunk(
    'topTenListeners/list',
    async (params = {}, { rejectWithValue }) => {
      try {
        const response = await GET('/admin/dashboard/top-listener', {...params});
  
        if (response?.status === 200) {
          return response.data;
        }
  
        return rejectWithValue(response?.data || 'Something went wrong');
      } catch (error) {
        return rejectWithValue(
          error?.response?.data?.message || error?.message || 'Failed to fetch top listeners'
        );
      }
    }
  );


  export const fetchCategoryPodcastListener = createAsyncThunk(
    "dashboard/fetchcategory",
    async (params={}, { rejectWithValue }) => {
      try {
        const response = await GET(`/admin/dashboard/category`, {...params});
        if (response?.status === 200) {
          return response.data.result;
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to fetch dashboard podcast data");
      }
    }
  );






const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardCountData: {},
    dashboardCountLoading: false,
    dashboardCountError: null,
    dashboardUserData: {},
    dashboardUserLoading: false,
    dashboardUserError: null,
    dashboardPodcastLisnersData: {},
    dashboardPodcastLisnersLoading: false,
    dashboardPodcastLisnersError: null,

    dashboardTopHundredLisnersData: [],
    dashboardTopHundredLisnersCount: '',
    dashboardTopHundredLisnersLoading: false,
    
    dashboardTopHundredLisnersError: null,

    dashboardTopLeastLisnersData: [],
    dashboardTopLeastLisnersCount: '',
    dashboardTopLeastLisnersLoading: false,
    dashboardTopLeastLisnersError: null,

    dashboardTopTenLisnersData: [],
    dashboardTopTenLisnersLoading: false,
    dashboardTopTenLisnersError: null,

    dashboardCategoryLisnersData: [],
    dashboardCategoryLisnersLoading: false,
    dashboardCategoryLisnersError: null,


  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardCount.pending, (state) => {
        state.dashboardCountLoading = true;
        state.dashboardCountError = null;
      })
      .addCase(fetchDashboardCount.fulfilled, (state, action) => {
        state.dashboardCountLoading = false;
        state.dashboardCountData = action.payload;
      })
      .addCase(fetchDashboardCount.rejected, (state, action) => {
        state.dashboardCountLoading = false;
        state.dashboardCountError = action.payload;
      })


      .addCase(fetchCategoryPodcastListener.pending, (state) => {
        state.dashboardCategoryLisnersLoading = true;
        state.dashboardCategoryLisnersError = null;
      })
      .addCase(fetchCategoryPodcastListener.fulfilled, (state, action) => {
        state.dashboardCategoryLisnersLoading = false;
        state.dashboardCategoryLisnersData = action.payload;
      })
      .addCase(fetchCategoryPodcastListener.rejected, (state, action) => {
        state.dashboardCategoryLisnersLoading = false;
        state.dashboardCategoryLisnersError = action.payload;
      })





      

      .addCase(fetchDashboardUsers.pending, (state) => {
        state.dashboardUserLoading = true;
        state.dashboardUserError = null;
      })
      .addCase(fetchDashboardUsers.fulfilled, (state, action) => {
        state.dashboardUserLoading = false;
        state.dashboardUserData = action.payload;
      })
      .addCase(fetchDashboardUsers.rejected, (state, action) => {
        state.dashboardUserLoading = false;
        state.dashboardUserError = action.payload;
      })

      .addCase(fetchDashboardPodcastListener.pending, (state) => {
        state.dashboardPodcastLisnersLoading = true;
        state.dashboardPodcastLisnersError = null;
      })
      .addCase(fetchDashboardPodcastListener.fulfilled, (state, action) => {
        state.dashboardPodcastLisnersLoading = false;
        state.dashboardPodcastLisnersData = action.payload;
      })
      .addCase(fetchDashboardPodcastListener.rejected, (state, action) => {
        state.dashboardPodcastLisnersLoading = false;
        state.dashboardPodcastLisnersError = action.payload;
      })

      .addCase(listTop100Listeners.pending, (state) => {
        state.dashboardTopHundredLisnersLoading = true;
        state.dashboardTopHundredLisnersError = null;
      })
      .addCase(listTop100Listeners.fulfilled, (state, action) => {
        state.dashboardTopHundredLisnersLoading = false;
        state.dashboardTopHundredLisnersCount = action?.payload?.result.count;
        state.dashboardTopHundredLisnersData = action?.payload?.result.rows;
      })
      .addCase(listTop100Listeners.rejected, (state, action) => {
        state.dashboardTopHundredLisnersLoading = false;
        state.dashboardTopHundredLisnersError = action.payload;
      })

      .addCase(listTopLeastListeners.pending, (state) => {
        state.dashboardTopLeastLisnersLoading = true;
        state.dashboardTopLeastLisnersError = null;
      })
      .addCase(listTopLeastListeners.fulfilled, (state, action) => {
        state.dashboardTopLeastLisnersLoading = false;
        state.dashboardTopLeastLisnersCount = action?.payload?.result.count;
        state.dashboardTopLeastLisnersData = action?.payload?.result.rows;
      })
      .addCase(listTopLeastListeners.rejected, (state, action) => {
        state.dashboardTopLeastLisnersLoading = false;
        state.dashboardTopLeastLisnersError = action.payload;
      })

      .addCase(listTopTenListeners.pending, (state) => {
        state.dashboardTopTenLisnersLoading = true;
        state.dashboardTopTenLisnersError = null;
      })
      .addCase(listTopTenListeners.fulfilled, (state, action) => {
        state.dashboardTopTenLisnersLoading = false;
        state.dashboardTopTenLisnersData = action?.payload?.result.rows;
      })
      .addCase(listTopTenListeners.rejected, (state, action) => {
        state.dashboardTopTenLisnersLoading = false;
        state.dashboardTopTenLisnersError = action.payload;
      });

  },
});

export default dashboardSlice.reducer;
